/**
 * ClinicalHUD marketing surfaces — navy backdrop + sparse metal-gold accents.
 * ClinicalHUD-owned tokens; do not import FusionMSI/ASI layout components.
 */
import { darkTheme } from '@asi/design-tokens';

const { navyDeep, navy, secondaryDark, goldMetal, goldMetalText } =
  darkTheme.colors;

/** Dark-mode marketing page backdrop */
export const CLINICALHUD_MARKETING_GRADIENT_DARK = `linear-gradient(155deg, ${navyDeep} 0%, ${navy} 55%, ${secondaryDark} 100%)`;

/** Fill gradient — thin rules, small brand marks */
export const CLINICALHUD_GOLD_METAL = goldMetal;

/** Text fill — brand wordmark / single hero signal (clip to text) */
export const CLINICALHUD_GOLD_METAL_TEXT = goldMetalText;

/** sx helper for metal-gradient clipped text */
export const clinicalHudGoldMetalTextSx = {
  background: CLINICALHUD_GOLD_METAL_TEXT,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

/** sx helper for primary CTAs — metal fill, not flat palette.primary */
export const clinicalHudGoldMetalButtonSx = {
  background: CLINICALHUD_GOLD_METAL,
  color: 'primary.contrastText',
  fontWeight: 700,
  '&:hover': {
    background: CLINICALHUD_GOLD_METAL,
    opacity: 0.92,
  },
};
